import React from 'react';
import '../style.css';

const Gallery = () => {
  const galleryImages = [
    "image1.png",
    "image2.png",
    "image3.png",
    "image4.png",
    "image5.png",
    "image6.png",
    "image7.png",
    "image8.png",
    "image9.png",
    "image10.png",
    "image12.png",
    "image1.png",
    "image2.png",

  ];

  return (
    <div className="fis-main">
      <div className="fis-grid">
        {galleryImages.map((image, index) => (
          <div key={index} className="fis-item">
            <img 
              src={image} 
              alt="" 
              className="fis-img"
              loading="lazy"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Gallery;